/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmIszrUrovenPristupu extends GContentBase<SeznamAdmIszrUrovenPristupuObj> {
        private seznamObj: SeznamAdmIszrUrovenPristupuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmIszrUrovenPristupuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmIszrUrovenPristupuNew",
                contentCaption: "jres:33000764", //RC 33000764 : �rovn� p��stupu agendy
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_tre_txt} - {agenda}"
                },
                gridSettings: {
                    columnOrder: "ixs_tre_txt,ur_pri_txt,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmIszrUrovenPristupuObj extends GAdmSeznamBase {
        agenda: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmIszrUrovenPristupu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen,
            }], {
                ID: "DetailAdmIszrUrovenPristupu",
                newRecord: isNew,
                agenda: isNew == true ? ((this.agenda != null) ? this.agenda : null) : data.agenda,
                ixs_tre: isNew == true ? null : data.ixs_tre
            }, {
                height: 800,
                width: 800
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000757").addField("gselectbox", Gordic.Prefabs.Select.szrsage(), { //RC 33000757 : Agenda
                name: "agenda",
                model: "model.agenda=value.agenda",
                dropdown: true,
                disabled: this.agenda ? true : false
            }) 
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.agenda)
                hardFilter["agenda"] = this.agenda;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.agenda)
                data["agenda"] = this.agenda;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmIszrUrovenPristupu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.ixs_tre, data.agenda),
                nazev: "{0} x {1}".format(data["ixs_tre_txt"], data["agenda"])
            }
        }
    }
}